import React from 'react';

import {
  maxValue,
  minValue,
  required,
  SelectInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import NumberInput from '../../layout/inputFields/NumberInput';
import InfoPopover from '../../layout/InfoPopover';
import Label from '../../../customFields/Label';

import { timePeriodChoices } from '../../../constants/timePeriods';

const EntityDistinctIpCount = () => (
  <Grid size={12}>
    <Grid container gap={1}>
      <Grid size={12}>
        <NumberInput
          fullWidth
          source="ruleParameters.threshold"
          label="Threshold"
          validate={[required(), minValue(0), maxValue(99)]}
          popups={(
            <InfoPopover title="Distinct IP threshold" content="Triggers when the entity has used more than this many distinct IP addresses within the lookback period." />
          )}
        />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="Lookback period"
          info="How far back to look for distinct IP addresses used by the entity."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberInput
          source="ruleParameters.lookbackPeriod.amount"
          fullWidth
          label="Length"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectInput
          source="ruleParameters.lookbackPeriod.unit"
          choices={timePeriodChoices}
          fullWidth
          label="Unit"
          validate={[required()]}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default EntityDistinctIpCount;
